// Permission helpers — names must match /app/backend/permissions.py
export const PERM = {
  // Questions
  QUESTIONS_UPLOAD: "questions.upload",
  QUESTIONS_VIEW: "questions.view",
  QUESTIONS_EDIT: "questions.edit",
  QUESTIONS_DELETE: "questions.delete",
  QUESTIONS_QC: "questions.qc",
  QUESTIONS_EXPORT: "questions.export",
  // Batches
  BATCHES_CREATE: "batches.create",
  BATCHES_DELETE: "batches.delete",
  BATCHES_VIEW_ALL: "batches.view_all",
  BATCHES_DECLINE: "batches.decline",
  // Reviews
  REVIEWS_SUBMIT: "reviews.submit",
  // Tags
  TAGS_MANAGE: "tags.manage",
  // Users
  USERS_MANAGE: "users.manage",
  USERS_LOCK_UNLOCK: "users.lock_unlock",
  // Meta
  PERMISSIONS_GRANT: "permissions.grant",
  DATA_RESET: "data.reset",
};

export function hasPerm(user, perm) {
  if (!user || user === false) return false;
  const perms = user.permissions || [];
  return perms.includes(perm);
}

export function hasAny(user, perms) {
  return perms.some((p) => hasPerm(user, p));
}
